'use client';

import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@eliadmin/core/src/components/ui/tabs';
import { CoursesList } from '../courses/courses-list';
import type { CourseCategory } from '@eliadmin/core/src/api/courses/coursers-api';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { CourseListSeed } from '../courses/public-course-list';

const DANCE_CLASSES_TYPE = 1;
const WORKOUTS_TYPE = 2;

interface OnlineClassesCoursesListProps {
  locale: string;
  allCategories: CourseCategory[];
  initialCourses?: CourseListSeed;
}

export function OnlineClassesCoursesList({ locale, allCategories, initialCourses }: OnlineClassesCoursesListProps) {
  const [courseTypeId, setCourseTypeId] = useState<number>(DANCE_CLASSES_TYPE);

  return (
    <section className={cn('custom-section', 'mt-10 pr-0 sm:mt-12 lg:mt-14 xl:mt-16')}>
      <div className={cn('custom-container', 'mb-6 sm:mb-8 lg:mb-10')}>
        <Tabs
          value={String(courseTypeId)}
          onValueChange={val => setCourseTypeId(Number(val))}
        >
          <TabsList className="flex h-fit w-fit items-start justify-start gap-2 !rounded-none bg-transparent p-0">
            <TabsTrigger
              value={String(DANCE_CLASSES_TYPE)}
              className="ea-courses-list__trigger whitespace-nowrap px-3 py-2 text-xs font-bold transition-all sm:py-3 sm:text-sm lg:px-4 lg:py-[14px] xl:text-base"
            >
              Dance Classes
            </TabsTrigger>
            <TabsTrigger
              value={String(WORKOUTS_TYPE)}
              className="ea-courses-list__trigger whitespace-nowrap px-3 py-2 text-xs font-bold transition-all sm:py-3 sm:text-sm lg:px-4 lg:py-[14px] xl:text-base"
            >
              Workouts
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <CoursesList locale={locale} allCategories={allCategories} courseTypeId={courseTypeId} initialCourses={initialCourses} />
    </section>
  );
}
